import { render, staticRenderFns } from "./IconSlider.vue?vue&type=template&id=2926efd5&scoped=true"
import script from "./IconSlider.vue?vue&type=script&lang=js"
export * from "./IconSlider.vue?vue&type=script&lang=js"
import style0 from "./IconSlider.vue?vue&type=style&index=0&id=2926efd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2926efd5",
  null
  
)

export default component.exports